/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetAvailableCanadianProvinces$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAvailableCanadianProvincesRequest = createAction<PayloadData<void>>('GET_AVAILABLE_CANADIAN_PROVINCES__GET_AVAILABLE_CANADIAN_PROVINCES__REQUEST');
export const getAvailableCanadianProvincesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_AVAILABLE_CANADIAN_PROVINCES__GET_AVAILABLE_CANADIAN_PROVINCES__SUCCESS');
export const getAvailableCanadianProvincesFailure = createAction<PayloadData<Error, void, true>>('GET_AVAILABLE_CANADIAN_PROVINCES__GET_AVAILABLE_CANADIAN_PROVINCES__FAILURE');

export const getAvailableCanadianProvincesActions = [
    getAvailableCanadianProvincesRequest,
    getAvailableCanadianProvincesSuccess,
    getAvailableCanadianProvincesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAvailableCanadianProvinces = (config?: GetAvailableCanadianProvinces$Config) => {
    return {
        CALL_API: {
            types: getAvailableCanadianProvincesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/canadian-provinces`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

